import React from 'react';
import { SvgIcon } from '@mui/material';
import { useSteps } from 'components/Booking-new/hooks';

import { ReactComponent as DrSmileImpressLogo } from 'mui/assets/icons/DRSXIMPRESS.svg';
import { ReactComponent as DrSmileLogoIcon } from 'mui/assets/icons/drsmile-black-logo.svg';
import stepTypes from '../../../../../../components/Booking-new/modules/Steps/types';

import { isDRSmileInactive } from '../../../../../../data/isDRSmileInactive';
import { StyledHeader } from './styles';

const SimpleProgressHeader = () => {
  const { activeStepType, activeStepIndex, allStepsCount, goToPrevStep, allSteps, goToStep } = useSteps();
  const locationStepIndex = allSteps.findIndex(step => step?.type === stepTypes.location);
  const brandLogo = isDRSmileInactive ? DrSmileLogoIcon : DrSmileImpressLogo;
  const progress =
    activeStepType === 'ContentfulBookingStepReschedule' || activeStepType === 'ContentfulBookingStepSummary'
      ? allStepsCount
      : (activeStepIndex + 1) / allStepsCount;
  const isLastStep = allStepsCount - 1 <= activeStepIndex;

  const isWaitList = activeStepType === 'WaitlistData';

  const shouldRenderButton = (!isLastStep && activeStepIndex - 1 >= 0) || isWaitList;

  function handleGoBackStep() {
    if (isWaitList) goToStep(locationStepIndex);
    else goToPrevStep();
  }

  return (
    <StyledHeader
      progress={progress}
      hasBackButton={shouldRenderButton}
      $isDRSmileInactive={isDRSmileInactive}
      style={{ backgroundColor: 'white' }}
    >
      {shouldRenderButton && (
        <button onClick={handleGoBackStep} title="Back to the previous page" aria-label="Previous page" />
      )}
      <SvgIcon component={brandLogo} inheritViewBox={true}></SvgIcon>
      <div />
    </StyledHeader>
  );
};

export default SimpleProgressHeader;
